import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isNil } from 'lodash';
import clsx from 'clsx';
import CurrencyInput from 'react-currency-input-field';

import { uuid } from '../utils/files/functions';

const Input = ({
  onChange = null,
  onClick = null,
  onBlur = null,
  disabled = false,
  className = '',
  label = '',
  value = '',
  name = '',
  type = 'text',
  customRegex = null,
  maxLength,
  hasError = null, // ENVIAR UN TEXTO O COMPONENTE
  hasSpan = null, // ENVIAR UN TEXTO O COMPONENTE
  id = uuid(),
  sufixHolder = null,
  sufixSolid = false,
  onLoading = false,
  textLoading = false,
  onlyLetters = false,
  inputId,
  isCurrency = false,
  currencyPrefix = 'S/ ',
  currencyPrecision = 2,
  currencyValue = '',
  ...props
}) => {
  const refInput = useRef(null);
  const [active, setActive] = useState('');
  const [val, setVal] = useState(value || '');
  const [curCurrencyValue, setCurCurrencyValue] = useState(currencyValue);
  // const [currentCurrency, setCurrentCurrencyValue] = useState(currencyValue);

  // console.log("currency value");
  // console.log(curCurrencyValue);

  const regexByTypeInput = {
    number: /[^0-9]/g,
    text: /[^a-zA-ZÁÉÍÓÚáéíóúñÑ ]/gi, // eslint-disable-next-line
    decimal: /[^\d+(\.\d{1,2})?]/,
    alphaNumeric: /[^a-z0-9]/gi,
  };

  useEffect(() => {
    if (val !== value) {
      setVal(value);
    }
  }, [value]);

  useEffect(() => {
    if (curCurrencyValue !== currencyValue) {
      setCurCurrencyValue(currencyValue);
    }
  }, [currencyValue]);

  const hasPoint = (str) => str.includes('.');

  const limitDecimal = (number, decimal = 2) => {
    if (!hasPoint(number)) {
      return number;
    }
    const numberAbs = number.split('.')[0];
    const numberDecimal = number.split('.')[1];
    const limit = numberDecimal.slice(0, decimal);
    return `${numberAbs}.${limit}`;
  };

  const handleChange = (event) => {
    if (!disabled && onChange) {
      let text = event.target.value;

      if (!isNil(customRegex)) {
        if (isEmpty(text) || customRegex.test(text)) {
          onChange(text);
          setVal(text);
        }
        return;
      }

      if (type !== 'text') {
        text = text.replace(regexByTypeInput[type], '');
      } else if (onlyLetters) {
        text = text.replace(regexByTypeInput.text, '');
      }

      if (type === 'decimal') {
        text = limitDecimal(text);
      }

      onChange(text);
      setVal(text);
    }
  };

  const handleCurrencyChange = (value) => {
    if (!value) {
      onChange('');
      setCurCurrencyValue('');
      return;
    }

    onChange(value);
    setCurCurrencyValue(value);
  };

  const handleMouseDown = (event) => {
    if (!refInput || refInput.current.contains(event.target)) {
      return;
    }

    setActive('');
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  const setDefaultPropsInput = () => {
    let defaultPropsInput = {
      type: 'text',
    };

    // if(type === 'number') {
    //   defaultPropsInput.type = 'number';
    // }

    if (type === 'decimal') {
      defaultPropsInput.type = 'number';
      defaultPropsInput.step = '0.00';
      defaultPropsInput.inputMode = 'decimal';
    }

    if (!isEmpty(inputId)) {
      defaultPropsInput.id = inputId;
    }

    return defaultPropsInput;
  };

  const newProps = { ...props };
  delete newProps.errorClass;

  return (
    <>
      <div
        id={id}
        ref={refInput}
        className={clsx('rd--input', active, className, {
          disabled,
          filled: !isEmpty(val) || !isEmpty(currencyValue),
          'has-error': hasError,
          'has-span': hasSpan,
          'sufix--solid': sufixSolid,
        })}
        disabled={disabled}
        onClick={() => setActive('active')}
      >
        {onLoading ? (
          <div className="rd--input-loader">
            <div className="loadercontent loader">
              <div className="loader-style-1"></div>
            </div>
            <p>{textLoading}</p>
          </div>
        ) : isCurrency ? (
          <>
            <label>{label}</label>
            <CurrencyInput
              allowNegativeValue={false}
              value={curCurrencyValue}
              prefix={currencyPrefix}
              decimalsLimit={currencyPrecision}
              onValueChange={handleCurrencyChange}
              disableGroupSeparators={true}
              maxLength={maxLength}
              decimalSeparator="."
            />
          </>
        ) : (
          <>
            <label>{label}</label>
            <input
              name={name}
              maxLength={maxLength}
              value={val || ''}
              onChange={handleChange}
              onBlur={onBlur}
              onClick={onClick}
              disabled={disabled}
              pattern={type === 'number' ? 'd*' : ''}
              inputMode={type === 'number' ? 'numeric' : ''}
              {...setDefaultPropsInput()}
              {...newProps}
            />
            {sufixHolder && (
              <span className="rd--input--sufix">{sufixHolder}</span>
            )}
          </>
        )}
      </div>
      {hasSpan && (
        <div className="rd--input-span" htmlFor={id}>
          {hasSpan}
        </div>
      )}
      {hasError && (
        <span className={'rd--input-error ' + props.errorClass} htmlFor={id}>
          {hasError}
        </span>
      )}
    </>
  );
};

Input.propTypes = {
  customRegex: PropTypes.instanceOf(RegExp),
  inputId: PropTypes.string,
};

Input.defaultProps = {
  inputId: null,
};

export default Input;
